// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1YH3v","alert":"SettungsInbox_alert__3h4Dv"};